"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBundledIconStyles = void 0;
const react_1 = require("@griffel/react");
exports.useBundledIconStyles = react_1.__styles({
  "root": {
    "mc9l5x": "fjseox"
  },
  "visible": {
    "mc9l5x": "f1w7gpdv"
  }
}, {
  "d": [".fjseox{display:none;}", ".f1w7gpdv{display:inline;}"]
});